import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateRecepcionVehiculo } from '../../helpers/api_helper';

const useUpdateRecepcionVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const updateRecepcionHook = async (idRecepcion, recepcionData, usuario) => {
        setLoading(true);
        setError(null);
        try {
            const params = { tenantId, empresa, departamento };
            const payload = {
                recepcionData: recepcionData,
                usuario: usuario || userInfo?.name
            };
            const response = await updateRecepcionVehiculo(idRecepcion, payload, params);
            if (response) {
                return { success: true, data: response };
            } else {
                throw new Error('Error al actualizar la recepción');
            }
        } catch (err) {
            let errorMessage;
            let errorType = 'unknown';

            if (err.response) {
                // Server responded with error status
                const status = err.response.status;
                const serverMessage = err.response.data?.message || err.response.data?.error;

                if (status === 400) {
                    errorMessage = serverMessage || 'Error de validación en los datos enviados';
                    errorType = 'validation';
                } else if (status === 500) {
                    errorMessage = 'Error interno del servidor';
                    errorType = 'server';
                } else {
                    errorMessage = serverMessage || `Error del servidor (${status})`;
                    errorType = 'server';
                }
            } else if (err.request) {
                // Network error
                errorMessage = 'Error de conexión';
                errorType = 'network';
            } else {
                errorMessage = err.message || 'Error desconocido al actualizar';
                errorType = 'unknown';
            }

            setError(errorMessage);
            return { success: false, error: errorMessage, errorType };
        } finally {
            setLoading(false);
        }
    };

    return { updateRecepcionVehiculo: updateRecepcionHook, loading, error };
};

export default useUpdateRecepcionVehiculo;
